<template>
  <svg
    class="w-4 h-4"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 36 36"
    version="1.1"
  >
    <g id="surface2">
      <path
        fill="currentColor"
        stroke-width="15"
        d="M 35.152344 11.054688 C 35.503906 8.632812 34.671875 6.777344 32.941406 5.300781 C 29.882812 2.691406 24.15625 2.835938 21.234375 5.613281 C 20.859375 5.976562 20.632812 6.488281 20.605469 7.03125 C 20.160156 11.117188 19.871094 15.203125 20.292969 19.320312 C 20.46875 20.988281 20.570312 22.667969 20.644531 24.347656 C 20.683594 25.195312 20.253906 25.78125 19.476562 25.941406 C 18.640625 26.117188 18.046875 25.699219 17.753906 24.84375 C 17.628906 24.472656 17.542969 24.085938 17.496094 23.691406 C 16.855469 18.269531 16.691406 12.839844 17.40625 7.410156 C 17.550781 6.335938 17.277344 5.597656 16.402344 5.0625 C 13.039062 3.011719 9.605469 2.726562 6.183594 4.785156 C 4.167969 6 3.066406 7.855469 3.199219 10.519531 C 3.445312 16.175781 4.867188 21.703125 7.363281 26.6875 C 7.847656 27.644531 8.398438 28.558594 9.015625 29.421875 C 14.625 37.386719 23.886719 37.375 29.40625 29.351562 C 33.128906 23.933594 34.613281 17.636719 35.152344 11.054688 Z M 35.152344 11.054688 "
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
